import dayjs from "dayjs";
import { offlineHandler } from "./offlineCache";

/****************************************************
 * ##: Create API Client Auth
 * @param {Object} authData - Authentication data
 * History:
 * 09-01-2026: Created
 ****************************************************/
export const createAPIClientAuth = (authData) => {
  try {
    if (!authData) return null;
    return {
      onRequest: (config) => {
        return offlineHandler(config);
      },
      authHeaders: {
        "x-user": authData?._id,
        "x-boats-token": authData?.token,
        fromboats: true,
      },
      baseURL: process.env.REACT_APP_API_URL + process.env.REACT_APP_MOBILE_URL,
    };
  } catch (error) {
    console.error("Error creating API client auth", error);
    return null;
  }
};

/****************************************************
 * ##: Create API Client
 * only used for login and authentication
 * History:
 * 20-01-2026: Created
 ****************************************************/
export const createAPIClient = () => {
  try {
    return {
      onRequest: (config) => {
        return offlineHandler(config);
      },
      baseURL: process.env.REACT_APP_API_URL,
      onAuthError: (error) => {
        const status = error?.response?.status;

        if (status === 401) {
          window.localStorage.removeItem("md-auth-boats");
          window.location.href = "/login";
        }
      },
    };
  } catch (error) {
    console.error("Error creating API client auth", error);
    return null;
  }
};

export const getCurrentPrice = (sellPriceArray, referenceDate = new Date()) => {
  if (!Array.isArray(sellPriceArray) || sellPriceArray.length === 0) return 0;

  const validPrices = sellPriceArray
    .filter((priceObj) => !priceObj.start_date || dayjs(priceObj.start_date).isBefore(referenceDate) || dayjs(priceObj.start_date).isSame(referenceDate))
    .sort((a, b) => {
      if (!a.start_date && !b.start_date) return 0;
      if (!a.start_date) return -1;
      if (!b.start_date) return 1;
      return dayjs(b.start_date).valueOf() - dayjs(a.start_date).valueOf();
    });

  return validPrices.length > 0 ? validPrices[0]?.price || 0 : 0;
};

export const cropStaffName = (staffName) => {
  try {
    if (!staffName) return staffName;
    const splittedStaffName = staffName.split("-");
    const abreviation = splittedStaffName[1].trim();
    const secondSplit = splittedStaffName[0].trim().split(" ");
    const firstName = secondSplit[0].trim();
    const lastName = secondSplit[secondSplit.length - 1].trim();

    const Name = `${firstName} ${lastName} ${abreviation ? "- " + abreviation : ""}`;

    return Name;
  } catch (error) {
    return staffName;
  }
};
